import { createStore as reduxCreateStore, applyMiddleware, compose } from 'redux';
import { persistStore, autoRehydrate } from 'redux-persist-immutable';
import createSagaMiddleware from 'redux-saga';

import crashReporter from './crashReporter';
import sagas from './sagas';
import reducer from './reducer';

export default function createStore() {
  const sagaMiddleware = createSagaMiddleware();
  // eslint-disable-next-line
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    // eslint-disable-next-line
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      maxAge: 200,
    }) : compose;
  const store = reduxCreateStore(reducer, undefined, composeEnhancers(
    applyMiddleware(
      sagaMiddleware,
      crashReporter,
    ),
    autoRehydrate(),
  ));

  sagas.forEach(saga => sagaMiddleware.run(saga));
  persistStore(store, { whitelist: ['session', 'PersistedState'] });
  return store;
}
